import { Info } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

type InformationHoverIconProps = {
  information: string;
  className?: string;
};

export const InformationHoverIcon = ({
  information,
  className,
}: InformationHoverIconProps) => (
  <TooltipProvider delayDuration={200}>
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          aria-label="Más información"
          className="inline-flex h-11 w-11 items-center justify-center md:h-6 md:w-6"
        >
          <Info
            className={cn(
              "size-4 cursor-pointer text-muted-foreground transition-colors hover:text-palomma-secondary",
              className
            )}
          />
        </button>
      </TooltipTrigger>
      <TooltipContent
        side="top"
        sideOffset={8}
        className="max-w-[500px] rounded-md bg-palomma-secondary px-3 py-2 text-center text-sm text-white"
      >
        {information}
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
);
